// IEA Site Survey Photos mode on the Map screen. Words: IEA_PHOTO_VIEWER_WORDS.md (Robert 2026-10-16).
// The Map page owns the screen; Collect owns the records; this module owns the photo panel.
// Pictures and the big view are shared with Collect (survey-photo-store.ts).

import { photoCount, photoTotal, type Site } from "./survey-collect";
import type { PhotoDecor } from "./survey-map-screens";
import { srcOf, uploadMark } from "./survey-photo-store";
import { panelFocus, photosPanel } from "./survey-photos-screens";

export interface PhotosCtx {
  siteNumber: string;
  site: () => Site;
  cur: () => string | null;
  paint: () => void;
}

let ctx: PhotosCtx | null = null;
let row: string | null = null;

export function photosInit(c: PhotosCtx): void {
  ctx = c;
}

/** The diagram's Photos layer and the left panel. */
export function photosDecor(): PhotoDecor {
  const site = ctx!.site();
  return {
    count: (key) => {
      const n = site.tree.nodes.get(key);
      return n ? photoCount(site, n) : null;
    },
    total: photoTotal(site),
    panel: photosPanel(site, { siteNumber: ctx!.siteNumber, cur: ctx!.cur(), row, src: srcOf, mark: uploadMark }),
  };
}

/** A node tapped in Photos mode. A new node starts on its own photos. */
export function photosSelected(key: string): string {
  row = null;
  return key;
}

export function openRow(point: string | null): void {
  row = point;
  ctx?.paint();
}

/** Where Open in Collect goes: the node, and the row when one is open. */
export function collectTarget(): { key: string; row: string | null } | null {
  if (!ctx) return null;
  const cur = ctx.cur();
  if (!cur) return null;
  const f = panelFocus(ctx.site(), { cur, row });
  if (f.kind === "row" && f.fromHousing) return { key: cur, row: f.point };
  return { key: cur, row: null };
}
